import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth, arrowWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_BLUE } from "../../config/constants";
import TrackArrow from "../UI/TrackArrow";

const Connector9ABlue13BRed = ({ state, workState }) => (
	<g transform="translate(1581.000000, 1116.000000)">
		<g transform="translate(0.000000, -0.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			 strokeLinecap="round"
		>
			<line x1="213" y1="400" x2="193.511985" y2="349.782186" strokeWidth={tracksWidth}/>

			<TrackArrow transform="translate(194.056549, 351.447573) rotate(-289.000000) translate(-194.056549, -351.447573) "
									points="198.056549 359.447573 190.056549 351.447573 198.056549 343.447573"/>

			<line x1="188.813419" y1="338.006374" x2="171" y2="291" id="line-copy-5" strokeWidth={tracksWidth}/>
		</g>
	</g>
);

export default Connector9ABlue13BRed;
